<template>
    <div class="input-wrapper">
      <input
        class="form-control"
        :name="name"
        :required="required"
        :disabled="disabled"
        :id="id"
        :type="type"
        :placeholder="placeholder"
        :value="modelValue"
        @input="handleInput($event)"
        :autocomplete="autocomplete"
        :readonly="readonly"
        :onfocus="onfocus"
        :min="min"
        :max="max"
        :maxlength="maxlength"
      />
    </div>
    <span
      class="message"
      v-if="validMessageCom !== ''"
      :class="{ 'text-success': isValidCom, 'text-danger': !isValidCom }"
    >
      {{ validMessage }}
    </span>
</template>
<script>
export default {
    inheritAttrs: false,
    props:{
        name: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
        },
        type: {
            type: String,
            default: 'text'
        },
        placeholder: {
            type: String
        },
        modelValue:{
            type: [String, Number]
        },
        isValid:{
            type: Boolean,
            default: true
        },
        validMessage:{
            type: String,
            default: ''
        },
        mask:{
            type: String,
        },
        autocomplete: {
            type: String,
        },
        onfocus: {
            type: String,
        },
        min: {
            type: [String, Number]
        },
        max: {
            type: [String, Number]
        },
        numbersOnly: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: [String, Number]
        }
    },
    name: "OInputText",
    computed: {
      validMessageCom: function () {
        if (this.validMessage === undefined) {
          return "";
        }
        return this.validMessage;
      },
      isValidCom: function () {
        if (this.isValid === undefined) {
          return true;
        }
        return this.isValid;
      },
    },
    methods: {
      handleInput(e) {
        let value = e.target.value;

        if (this.numbersOnly || this.type === 'number') {
            value = value.replace(/[^0-9]/g, '');
            if (value.length > 1 && value.startsWith('0')) {
                value = value.replace(/^0+/, '');
            }
        }

        if (this.mask) {
            let numericValue = value.replace(/\D/g, '');
            if (this.mask == "phone") {
                numericValue = numericValue.substring(0, 14);
                const x = numericValue.match(/(\d{0,2})(\d{0,3})(\d{0,4})(\d{0,5})/);
                value = !x[2]
                    ? x[1]
                    : "+" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "") + (x[4] ? "-" + x[4] : "");
            } else if (this.mask == "fax") {
                numericValue = numericValue.substring(0, 33);
                const x = numericValue.match(/(\d{0,2})(\d{0,3})(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
                value = !x[2]
                    ? x[1]
                    : "+" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "") + (x[4] ? "-" + x[4] : "") + (x[5] ? "-" + x[5] : "") + (x[6] ? "-" + x[6] : "") + (x[7] ? "-" + x[7] : "") + (x[8] ? "-" + x[8] : "") + (x[9] ? "-" + x[9] : "");
            } else if (this.mask == "mobile") {
                numericValue = numericValue.substring(0, 14);
                const x = numericValue.match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,6})/);
                value = !x[2]
                    ? x[1]
                    : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "") + (x[4] ? "-" + x[4] : "");
            } else if (this.mask == "idr") {
                if (this.max !== undefined) {
                    numericValue = numericValue.substring(0, parseInt(this.max));
                }
                const x = numericValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
                value = x;
            }
        }

        if (this.numbersOnly || this.type === 'number') {
            let numValue = parseFloat(value.replace(/[^0-9]/g, ''));
            if (this.max !== undefined && !isNaN(numValue) && numValue > parseFloat(this.max)) {
                value = this.max;
            }
            if (this.min !== undefined && !isNaN(numValue) && numValue < parseFloat(this.min)) {
                value = this.min;
            }
        }
        
        e.target.value = value;
        this.$emit("update:modelValue", value);
    },
    },
  };
  </script>
  
  <style scoped>
  .input-wrapper {
    position: relative;
    margin: 10px 0; 
  }
  
  .form-control {
    border: none;
    border-bottom: 1px solid var(--secondary-color, rgba(242, 113, 120, 0.2));
    outline: none; 
    border-radius: 0;
    padding: 8px; 
    margin-right: 10px;
    transition: border-color 0.2s ease;
  }

  .form-control:focus {
    border-bottom-color: var(--primary-color, #f27178);
  }
  
  .message {
    position: relative;
    margin-top: 8px;
  }
  
  .text-success {
    color: var(--success-color, #22c55e);
  }
  
  .text-danger {
    color: var(--danger-color, #ef4444);
  }
  </style>